import PropTypes from "prop-types";
import React, { useState, useRef, useEffect } from "react";
import analytics from "web/script/analytics/analytics";
import Button from "web/react/components/button/button";
import LeadLink from "web/react/components/lead-link/lead-link";
import { gettext } from "web/script/modules/django-i18n";
import classnames from "classnames";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./product-description-express-checkout-size-select.css";

function ProductDescriptionExpressCheckoutSizeSelect({ sizes, leadUrl, productId }) {
    const [isOpen, setOpen] = useState(false);
    const sizeSelect = useRef(null);

    function handler(e) {
        if (e.target != sizeSelect.current) {
            handleBlur();
        }
    }

    useEffect(() => {
        if (isOpen) {
            document.addEventListener("click", handler);
        }

        return () => {
            document.removeEventListener("click", handler);
        };
    });

    function toggleList() {
        setOpen(!isOpen);
    }

    function handleButtonClick() {
        setOpen(true);
        analytics.event("express_checkout", "select_box_clicked");
    }

    function handleSizeClick() {
        toggleList();
        analytics.event("express_checkout", "changed_size");
    }

    function handleBlur() {
        setOpen(false);
    }

    const sizeList = sizes.map((size, i) => {
        return (
            <li key={i} onClick={handleSizeClick}>
                {size.human_size + " - " + size.min_price}
            </li>
        );
    });

    const buttonLabel = sizes[0].human_size + " - " + sizes[0].min_price;

    return (
        <div
            className={classnames(styles.size_select, {
                [styles.is_open]: isOpen,
            })}
        >
            <Button
                className={styles.size_select_button}
                onClick={handleButtonClick}
                fullWidth
                styleType="secondary"
            >
                {buttonLabel}
                <SVGIcon
                    className={styles.chevron}
                    name="round-chevron"
                    rotate={isOpen ? -90 : 90}
                />
            </Button>
            <ul className={styles.size_select_list} ref={sizeSelect}>
                {sizeList}
                <li>
                    <LeadLink
                        href={leadUrl}
                        productId={productId}
                        openInNewTab={true}
                        reason="click-to-see-more-sizes"
                        afterOnClick={toggleList}
                    >
                        {gettext("product.buy_area.see_more_sizes")}
                    </LeadLink>
                </li>
            </ul>
        </div>
    );
}

export default ProductDescriptionExpressCheckoutSizeSelect;

ProductDescriptionExpressCheckoutSizeSelect.propTypes = {
    leadUrl: PropTypes.string.isRequired,
    productId: PropTypes.string.isRequired,
    sizes: PropTypes.arrayOf(
        PropTypes.shape({
            option_value: PropTypes.shape({
                link_id: PropTypes.string,
                raw_size: PropTypes.string,
                icon: PropTypes.bool,
            }),
            human_size: PropTypes.string,
            raw_size: PropTypes.string,
            min_price: PropTypes.string,
        })
    ),
};
